<template>
  <div class="past-medical-history">
    <div class="title">4.请确认以下信息</div>
    <el-form ref="form" label-width="160px" label-position="left">
      <el-form-item label="肝、肾功能是否正常" required v-if="hepatonephricConfig">
        <el-radio :value="hepatonephricStatus" @input="handleHepatonephricStatus" :label="true">是</el-radio>
        <el-radio :value="hepatonephricStatus" @input="handleHepatonephricStatus" :label="false">否</el-radio>
      </el-form-item>
      <el-form-item label="过往病史" required>
        <el-radio :value="diseaseHistoryStatus" @input="handleDiseaseHistoryStatus" :label="false">无</el-radio>
        <el-radio :value="diseaseHistoryStatus" @input="handleDiseaseHistoryStatus" :label="true">有</el-radio>
        <history-select v-model="history" placeholder="请选择过往病史（多选）" v-if="diseaseHistoryStatus">
          <history-select-option
            :value="option.value"
            :label="option.label"
            :mode="option.mode"
            :key="i"
            v-for="(option, i) in historyOptions"
          ></history-select-option>
        </history-select>
      </el-form-item>
      <el-form-item v-if="hasModifyRestriction" label="医保报销要求" required>
        <el-radio :value="medicalInsuranceStatus" @input="handleMedicalInsuranceStatus" :label="0">无</el-radio>
        <el-radio :value="medicalInsuranceStatus" @input="handleMedicalInsuranceStatus" :label="2">
          按以上填写的疾病名称报销
        </el-radio>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import historySelect from './components/select';
import historySelectOption from './components/select/option';

export default {
  name: 'pastMedicalHistory',
  components: {
    historySelect,
    historySelectOption
  },
  props: {
    hepatonephricStatus: {
      type: Boolean,
      default: false
    },
    diseaseHistoryStatus: {
      type: Boolean,
      default: false
    },
    medicalInsuranceStatus: {
      type: Number,
      default: 0
    },
    hasModifyRestriction: {
      type: Boolean,
      default: false
    },
    diseaseHistory: Array,
    hepatonephricConfig: Boolean
  },
  data() {
    return {
      radio: ''
    };
  },
  computed: {
    historyOptions() {
      return ['糖尿病', '高血压', '高血脂', '其他'].map(str => ({
        value: str,
        label: str,
        mode: str !== '其他' ? 'normal' : 'extra'
      }));
    },
    history: {
      get() {
        return this.diseaseHistory;
      },
      set(val) {
        this.$emit('changePastHistory', val);
      }
    }
  },
  methods: {
    handleHepatonephricStatus(val) {
      if (!val) {
        this.$alert('由于您的肝肾功能异常，暂不支持线上开具处方，建议您前往线下实体医院接受诊疗。', {
          customClass: 'hint',
          center: true,
          confirmButtonText: '知道了'
        });
      }
      this.$emit('handleHepatonephricStatus', val);
    },
    handleDiseaseHistoryStatus(val) {
      this.$emit('handleDiseaseHistoryStatus', val);
    },
    handleMedicalInsuranceStatus(val) {
      this.$emit('handleMedicalInsuranceStatus', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.past-medical-history {
  position: relative;
  margin-bottom: 30px;

  .title {
    margin-bottom: 11px;
    color: #242424;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
